module.exports = __webpack_public_path__ + "img/no-blocked-users.19e61369.svg";